import { useState } from 'react';
import { supabase } from './supabase';

export default function AuthModal({ onClose, onAuth }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    if (!email || !password) return setError('Email et mot de passe requis');
    setLoading(true); setError(''); setSuccess('');
    try {
      if (mode === 'login') {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;

        //  Vérifier si le compte est approuvé
        const { data: profile } = await supabase
          .from('profiles')
          .select('approved, pending, plan_expires_at, plan')
          .eq('id', data.user.id)
          .single();

        // Pas encore approuvé
        if (!profile?.approved) {
          await supabase.auth.signOut();
          throw new Error('⏳ Ton compte est en attente d\'approbation. Tu seras notifié quand ton accès sera activé.');
        }

        // Abonnement expiré
        if (profile?.plan_expires_at && new Date(profile.plan_expires_at) < new Date()) {
          await supabase.auth.signOut();
          throw new Error('Ton abonnement a expiré. Contacte l\'administrateur pour le renouveler.');
        }

        onAuth(data.user);
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setSuccess('Demande envoyée ! Tu recevras un accès quand ta demande sera approuvée.');
        setEmail(''); setPassword('');
      }
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={onClose}>
      <div style={{background:'#0b0e14',border:'1px solid rgba(0,229,204,0.3)',borderRadius:12,padding:32,width:380}} onClick={e=>e.stopPropagation()}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{fontSize:28,fontWeight:900,color:'#00e5cc',fontFamily:'monospace',letterSpacing:2}}>COPYCCXX</div>
          <div style={{fontSize:12,color:'#3a4a5a',marginTop:4}}>Copytrade Solana — Accès sur invitation</div>
        </div>
        <div style={{display:'flex',gap:8,marginBottom:20}}>
          {['login','signup'].map(m=>(
            <button key={m} onClick={()=>{setMode(m);setError('');setSuccess('');}}
              style={{flex:1,padding:'8px',borderRadius:6,background:mode===m?'rgba(0,229,204,0.1)':'transparent',border:`1px solid ${mode===m?'#00e5cc33':'#1a2030'}`,color:mode===m?'#00e5cc':'#5a6a80',fontSize:12,fontWeight:700,cursor:'pointer'}}>
              {m==='login'?'Connexion':'Inscription'}
            </button>
          ))}
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <input type="email"placeholder="Email"value={email} onChange={e=>setEmail(e.target.value)}
            style={{background:'#0d1117',border:'1px solid #1e2a38',borderRadius:6,color:'#c0c8d8',fontSize:13,padding:'11px 14px',outline:'none',width:'100%',boxSizing:'border-box'}}/>
          <input type="password"placeholder="Mot de passe"value={password} onChange={e=>setPassword(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&handleSubmit()}
            style={{background:'#0d1117',border:'1px solid #1e2a38',borderRadius:6,color:'#c0c8d8',fontSize:13,padding:'11px 14px',outline:'none',width:'100%',boxSizing:'border-box'}}/>
          {error&&<div style={{fontSize:11,color:'#ff6b6b',padding:'10px',background:'rgba(255,107,107,0.08)',borderRadius:6,lineHeight:1.6}}>{error}</div>}
          {success&&<div style={{fontSize:11,color:'#00e5cc',padding:'10px',background:'rgba(0,229,204,0.08)',borderRadius:6,lineHeight:1.6}}>{success}</div>}
          <button onClick={handleSubmit} disabled={loading}
            style={{padding:'12px',borderRadius:7,background:loading?'#0d1117':'linear-gradient(135deg,#00e5cc,#00b8a0)',border:loading?'1px solid #1a2030':'none',color:loading?'#5a6a80':'#060809',fontSize:14,fontWeight:800,cursor:loading?'not-allowed':'pointer'}}>
            {loading?'⏳ Chargement...':(mode==='login'?'Se connecter':'Demander l\'accès')}
          </button>
        </div>
        <div style={{marginTop:16,fontSize:10,color:'#2a3a4a',textAlign:'center'}}>
          Accès sur invitation · Tes données sont sécurisées
        </div>
      </div>
    </div>
  );
}